const GIFT_VARIANT_ID = 58599401521497;
const GIFT_BAG_VARIANT_ID = 59878660571481; // Bolsa de regalo de pago (2,99 €)
const GIFT_EXPIRY_KEY = 'mattera_gift_expiry';
const GIFT_DURATION_MS = 10 * 60 * 1000; // 10 minutos

/* ------------------------------------------------------------------ */
/* Banner de countdown                                                 */
/* ------------------------------------------------------------------ */

function ensureGiftExpiry() {
  const now = Date.now();
  let expiry = parseInt(localStorage.getItem(GIFT_EXPIRY_KEY), 10);

  if (!expiry || isNaN(expiry) || expiry < now) {
    expiry = now + GIFT_DURATION_MS;
    localStorage.setItem(GIFT_EXPIRY_KEY, String(expiry));
  }

  return expiry;
}

function isGiftExpired() {
  const expiry = parseInt(localStorage.getItem(GIFT_EXPIRY_KEY), 10);
  return !expiry || isNaN(expiry) || expiry < Date.now();
}

class MatteraGiftBanner extends HTMLElement {
  connectedCallback() {
    this.countdownEl = this.querySelector('[data-gift-countdown]');
    this.expiry = ensureGiftExpiry();
    this.tick();
    this.interval = setInterval(() => this.tick(), 1000);
  }

  disconnectedCallback() {
    if (this.interval) clearInterval(this.interval);
  }

  tick() {
    const remaining = this.expiry - Date.now();

    if (remaining <= 0) {
      this.style.display = 'none';
      clearInterval(this.interval);
      syncGift();
      return;
    }

    const totalSeconds = Math.floor(remaining / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    if (this.countdownEl) {
      const minLabel = minutes === 1 ? 'minuto' : 'minutos';
      const secLabel = seconds === 1 ? 'segundo' : 'segundos';
      this.countdownEl.textContent = minutes + ' ' + minLabel + ', ' + seconds + ' ' + secLabel;
    }
  }
}

if (!customElements.get('mattera-gift-banner')) {
  customElements.define('mattera-gift-banner', MatteraGiftBanner);
}

/* ------------------------------------------------------------------ */
/* Sincronización real con el carrito de Shopify                       */
/* ------------------------------------------------------------------ */

let matteraGiftBusy = false;

async function getCart() {
  const res = await fetch('/cart.js');
  return res.json();
}

function findGiftLine(cart) {
  return cart.items.find((item) => item.variant_id === GIFT_VARIANT_ID);
}

function findBagLine(cart) {
  return cart.items.find((item) => item.variant_id === GIFT_BAG_VARIANT_ID);
}

// Productos "reales": todo menos el regalo sorpresa y la bolsa de regalo
function countRealItems(cart) {
  return cart.items.reduce((sum, item) => {
    const isExtra =
      item.variant_id === GIFT_VARIANT_ID || item.variant_id === GIFT_BAG_VARIANT_ID;
    return isExtra ? sum : sum + item.quantity;
  }, 0);
}

async function addGiftToCart() {
  await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: GIFT_VARIANT_ID, quantity: 1 }] }),
  });
}

async function removeGiftFromCart(lineKey) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: lineKey, quantity: 0 }),
  });
}

async function fixGiftQuantity(giftLine) {
  if (giftLine.quantity !== 1) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: giftLine.key, quantity: 1 }),
    });
    return true;
  }
  return false;
}

async function refreshCartSection() {
  const cartItemsEl = document.querySelector('cart-items-component');
  const sectionId = cartItemsEl ? cartItemsEl.dataset.sectionId : null;
  if (!sectionId) return;

  const res = await fetch(window.location.pathname + '?section_id=' + sectionId);
  const html = await res.text();
  const doc = new DOMParser().parseFromString(html, 'text/html');

  const newComponent = doc.querySelector('cart-items-component');
  const oldComponent = document.querySelector('cart-items-component');

  if (newComponent && oldComponent) {
    oldComponent.replaceWith(newComponent);
  }
}

async function syncGift() {
  if (matteraGiftBusy) return;
  matteraGiftBusy = true;

  try {
    const cart = await getCart();
    const giftLine = findGiftLine(cart);
    const bagLine = findBagLine(cart);
    const realItemCount = countRealItems(cart);

    let changed = false;

    if (realItemCount > 0 && !giftLine && !isGiftExpired()) {
      ensureGiftExpiry();
      await addGiftToCart();
      changed = true;
    } else if (giftLine && (isGiftExpired() || realItemCount === 0)) {
      await removeGiftFromCart(giftLine.key);
      changed = true;
    } else if (giftLine && giftLine.quantity !== 1) {
      changed = await fixGiftQuantity(giftLine);
    }

    // La bolsa de regalo no tiene sentido sin ningún producto en el carrito
    if (bagLine && realItemCount === 0) {
      await removeGiftFromCart(bagLine.key);
      changed = true;
    } else if (bagLine && bagLine.quantity !== 1) {
      await fixGiftQuantity(bagLine);
      changed = true;
    }

    if (changed) {
      await refreshCartSection();
    }
  } catch (err) {
    console.error('Mattera gift sync error:', err);
  } finally {
    matteraGiftBusy = false;
  }
}

/* ------------------------------------------------------------------ */
/* Interceptamos el "añadir al carrito" en el instante que ocurre,     */
/* para reaccionar al momento en vez de esperar a detectarlo después.  */
/* ------------------------------------------------------------------ */

const originalFetch = window.fetch;

window.fetch = function (input, init) {
  const url = typeof input === 'string' ? input : input && input.url;
  const isCartAdd = url && url.indexOf('/cart/add') !== -1;

  // Ignoramos las peticiones que añaden el regalo sorpresa o la bolsa de regalo
  let bodyHasGift = false;
  if (isCartAdd && init && init.body) {
    const bodyText = String(init.body);
    bodyHasGift =
      bodyText.indexOf(String(GIFT_VARIANT_ID)) !== -1 ||
      bodyText.indexOf(String(GIFT_BAG_VARIANT_ID)) !== -1;
  }

  const fetchPromise = originalFetch.apply(this, arguments);

  if (isCartAdd && !bodyHasGift && !isGiftExpired()) {
    ensureGiftExpiry();

    fetchPromise
      .then(() => {
        setTimeout(() => {
          syncGift();
        }, 800);
      })
      .catch(() => {});
  }

  return fetchPromise;
};

/* ------------------------------------------------------------------ */
/* Casilla "Añadir bolsa de regalo" del carrito                        */
/* Usa delegación de eventos: sigue funcionando aunque el tema         */
/* vuelva a pintar el carrito.                                         */
/* ------------------------------------------------------------------ */

document.addEventListener('change', async (event) => {
  const input = event.target && event.target.closest
    ? event.target.closest('[data-mattera-gift-bag]')
    : null;
  if (!input) return;

  input.disabled = true;

  try {
    if (input.checked) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: GIFT_BAG_VARIANT_ID, quantity: 1 }] }),
      });
    } else {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: String(GIFT_BAG_VARIANT_ID), quantity: 0 }),
      });
    }

    await refreshCartSection();
  } catch (err) {
    console.error('Mattera gift bag error:', err);
  } finally {
    input.disabled = false;
  }
});

/* ------------------------------------------------------------------ */
/* Nota escrita del cliente: se guarda en el carrito mientras escribe  */
/* (así llega al pedido aunque pague con Google Pay u otro pago        */
/* exprés, que no envían el formulario del carrito).                   */
/* ------------------------------------------------------------------ */

let matteraNoteTimer = null;

function saveCartNote(value) {
  return fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ note: value }),
  }).catch((err) => console.error('Mattera note error:', err));
}

function findNoteField(event) {
  return event.target && event.target.closest
    ? event.target.closest('[data-mattera-cart-note]')
    : null;
}

document.addEventListener('input', (event) => {
  const field = findNoteField(event);
  if (!field) return;

  clearTimeout(matteraNoteTimer);
  matteraNoteTimer = setTimeout(() => saveCartNote(field.value), 600);
});

// Al salir del campo guardamos al instante, sin esperar
document.addEventListener('focusout', (event) => {
  const field = findNoteField(event);
  if (!field) return;

  clearTimeout(matteraNoteTimer);
  saveCartNote(field.value);
});

/* Casilla "Incluir mensaje personal": al marcarla se muestra el cuadro de
   texto; al desmarcarla se oculta y se borra el mensaje del carrito. */
document.addEventListener('change', (event) => {
  const toggle = event.target && event.target.closest
    ? event.target.closest('[data-mattera-gift-message-toggle]')
    : null;
  if (!toggle) return;

  const wrapper = toggle.closest('[data-mattera-gift-message]');
  if (!wrapper) return;

  const body = wrapper.querySelector('[data-mattera-gift-message-body]');
  const field = wrapper.querySelector('[data-mattera-cart-note]');
  if (!body || !field) return;

  if (toggle.checked) {
    body.hidden = false;
    field.focus();
  } else {
    body.hidden = true;
    clearTimeout(matteraNoteTimer);
    field.value = '';
    saveCartNote('');
  }
});

/* Se ejecuta al cargar cualquier página */
document.addEventListener('DOMContentLoaded', () => {
  syncGift();

  const bubble = document.querySelector('.cart-bubble__text-count') || document.body;
  const observer = new MutationObserver(() => {
    if (!matteraGiftBusy) syncGift();
  });
  observer.observe(bubble, { childList: true, characterData: true, subtree: true });
});

/* Comprobación periódica de seguridad */
setInterval(() => {
  if (!matteraGiftBusy) syncGift();
}, 30000);